{
  "activity": {
    "duration": "Durée",
    "durationUnit": "min",
    "intensity": "Intensité",
    "title": "Activité physique"
  },
  "admin": {
    "logout": "Déconnexion",
    "title": "Administration"
  },
  "alertConfig": {
    "atLeast": "Au moins",
    "bgm": "BGM",
    "capillaryMeasures": "Glycémie capillaire",
    "cgm": "CGM",
    "conditions": "Conditions",
    "conditionsError": "Erreur lors de la mise à jour des conditions pour l'alerte {{alert}}",
    "conditionsSuccess": "Les conditions pour l'alerte {{alert}} ont été mises à jour",
    "create": "Ajouter une notification",
    "createTitle": "Création de notification",
    "deleteError": "Erreur lors de la suppression de l'alerte {{alert}}",
    "deleteSuccess": "L'alerte {{alert}} a été supprimée",
    "highOrVeryHigh": "élevée ou très élevée",
    "hyperglycemiaEvent": "Evènement hyperglycémique",
    "hyperglycemiaEventTar": "Temps passé en hyperglycémie (TAR)",
    "hypoglycemiaEvent": "Evènement hypoglycémique",
    "hypoglycemiaEventTbr": "Temps passé en hypoglycémie (TBR)",
    "intervention": {
      "high": "Haute",
      "low": "Basse",
      "medium": "Moyenne"
    },
    "inThe": "dans les",
    "interstitialMeasures": "Glycémie interstitielle (CGM)",
    "lastDays": "derniers jours",
    "lowOrVeryLow": "basse ou très basse",
    "measurement": "Observance mesures",
    "measuresPerDay": "mesures de glycémie minimum par jour",
    "measuresPerDayNoMinumum": "mesure(s) de glycémie par jour",
    "monoInjection": "mono-injection",
    "moreThan": "plus de",
    "multiInjection": "multi-injections",
    "noAlertBGM": "Pas de notification BGM configurée, vous pouver en ajouter en cliquant sur le bouton ci-dessous",
    "noAlertCGM": "Pas de notification CGM configurée, vous pouver en ajouter en cliquant sur le bouton ci-dessous",
    "noAlertOther": "Pas de notification de type autre configurée, vous pouver en ajouter en cliquant sur le bouton ci-dessous",
    "noTransmission": "Pas de glycémie transmise",
    "notificationTriggeredAsSoonAsEventIsNoted": "Notification déclenchée dès que l'événement est constaté",
    "other": "Autre",
    "perceivedHyperglycemia": "Hyperglycémie ressentie",
    "perceivedHypoglycemia": "Hypoglycémie ressentie",
    "perceivedSevereHypoglycemia": "Hypoglycémie sévère déclarée",
    "periods": {
      "afterMeal": "Après repas",
      "all": "Toutes les périodes",
      "beforeMeal": "Avant repas",
      "fasting": "À jeun"
    },
    "priority": "Priorité",
    "priorityError": "Erreur lors de la mise à jour de la priorité",
    "prioritySuccess": "Priorité mise à jour",
    "scansPerDay": "scans minimum par jour",
    "severeHypoglycemia": "Hypoglycémie sévère",
    "technicalAlert": "Problèmes techniques",
    "timeInRange": "Temps dans la cible (TIR)",
    "timeInRangeSpent": "du temps passé dans la cible",
    "timeSpentInHyper": "du temps passé en moyenne en hyperglycémie",
    "timeSpentInHypo": "du temps passé en moyenne en hypoglycémie",
    "title": "Notifications",
    "transmission": "Observance transmission",
    "type": "Type d'alerte",
    "unspecified": "Non renseigné",
    "veryHigh": "très élevée",
    "veryLow": "très basse",
    "withdrawalOfConsent": "Retrait du consentement"
  },
  "atoms": {
    "richText": {
      "h5": "Titre",
      "normal": "Normal"
    }
  },
  "bgmLogBook": {
    "activityTooltip": "Activité physique : horaire, intensité",
    "average": "Moy. 7j",
    "cardTitle": "Carnet glycémique journalier",
    "comment": "Commentaire",
    "date": "Date",
    "downIsFuture": "Affichage date ascendante",
    "downIsPast": "Affichage date descendante",
    "eventTooltip": "Évènement : horaire - nature : commentaire",
    "fastInsulin": "Insuline Rapide",
    "fastInsulinHeader": "IR",
    "glycemia": "Glycémie",
    "glycemiaAfter": "Glycémie Post Prandiale, mg/dL",
    "glycemiaAfterHeader": "Post",
    "glycemiaBefore": "Glycémie Pré Prandiale, mg/dL",
    "glycemiaBeforeHeader": "Pré",
    "loadMore": "Charger plus",
    "loadOneMoreWeek": "Charger une semaine de plus",
    "mealTooltip": "Repas : consitance ou quantité de glucides, commentaire",
    "nightTime": "Coucher",
    "slowInsulin": "Insuline Lente",
    "slowInsulinHeader": "IL",
    "unknown": "Non spécifié"
  },
  "button": {
    "accept": "Accepter",
    "back": "Retour",
    "cancel": "Annuler",
    "edit": "Modifier",
    "generate": "Générer",
    "next": "Suivant",
    "pending": "Chargement…",
    "reject": "Rejeter",
    "save": "Sauvegarder",
    "submit": "Soumettre",
    "tryAgain": "Réessayer",
    "upload": "Joindre",
    "validate": "Valider"
  },
  "carePlanInterruption": {
    "action": "Mettre un terme au suivi",
    "modalTitle": "Mettre un terme au suivi",
    "modalSubtitle": "Raison de l'interruption du suivi :",
    "reasons": {
      "consentWithdrawal": "Retrait du consentement",
      "deceased": "Décès",
      "other": "Autre"
    },
    "successToast": "Le télésuivi a été interrompu."
  },
  "carePlans": {
    "history": "Historique",
    "historyTitle": "Historique des ordonnances",
    "historyPrescriptionTitle": "Ordonnance",
    "historyPeriodTitle": "Période",
    "historyTelemonitoringTierTitle": "Niveau",
    "historyTelemonitoringCriteriaTitle": "Critère d'inclusion",
    "historyObjectivesTitle": "Objectifs",
    "historyObjectivesText": "Texte",
    "historyObjectivesFile": "Ficher",
    "noCarePlans": "Aucune ordonnance trouvée",
    "copyDescription": "Copier les objectifs"
  },
  "charts": {
    "afterMeal": "Après repas",
    "basal": "Ins. lente",
    "beforeMeal": "Avant repas",
    "bolus": "Ins. rapide",
    "carbs": "Glucides",
    "correction": "Correction",
    "data": "Donnée",
    "events": "Événements",
    "extended": "Etendu",
    "glucose": "Glucose",
    "glycemia": {
      "glycemia": "Glucose",
      "glycemiaUnit": "mg/dL",
      "glycemia_short": "Glu."
    },
    "glycemiaSpread": "Répartition des glycémies",
    "inputMethod": {
      "manual": "Saisie",
      "pen": "Stylo",
      "pump": "Pompe",
      "reader": "Capillaire",
      "sensor": "Interstitielle"
    },
    "instant": "Instant",
    "insulin": {
      "basalRate": "Débit basal",
      "basalRateUnit": "U/h",
      "basalRate_short": "Basal",
      "bolus": "Bolus",
      "bolusUnit": "U",
      "carbs": "Glucides",
      "carbsUnit": "g",
      "carbs_short": "Gluc.",
      "closedLoop": "Modes",
      "fast": "Ins. rapide",
      "fastUnit": "U",
      "fast_short": "IR",
      "slow": "Ins. lente",
      "slowUnit": "U",
      "slow_short": "IL"
    },
    "manual": "Saisie",
    "meal": "Repas",
    "noData": "Aucune donnée à afficher",
    "timeBetweenThresholds": "Temps entre les seuils"
  },
  "clipboard": {
    "unsupported": "La copie dans le presse-papiers n'est pas disponible",
    "copied": "Contenu copié dans le presse-papiers",
    "failed": "Échec de la copie du contenu dans le presse-papiers"
  },
  "condition": {
    "term": "Terme",
    "unspecified": "Non renseigné"
  },
  "contact": {
    "addRelationship": "Ajouter une relation",
    "editRelationship": "Modifier la relation",
    "emergencyContact": "À contacter en cas d'urgence ?",
    "entourage": "Entourage",
    "notEntered": "Non saisi",
    "relationshipWithPatient": "Lien avec le patient",
    "noName": "Nom non renseigné"
  },
  "devices": {
    "libreLink": "Via LibreView",
    "manual": "Saisie manuelle",
    "pen": "Stylo à insuline",
    "pump": "Pompe à insuline",
    "reader": "Lecteur",
    "sensor": "Capteur interstitiel"
  },
  "nurseInclusion": {
    "doctorSelect": "Médecin télésurveillant",
    "nurseSelect": "Infirmier télésurveillant",
    "patientInfo": "Informations patient",
    "banner": "Le patient recevra un mail de connexion une fois que le médecin aura validé l’inclusion",
    "inclusionReason": "Raison de la proposition d’inclusion",
    "inclusionSent": "Proposition envoyée avec succès",
    "inclusionProposal": "Proposition d’inclusion",
    "inclusionProposalBy": "Proposition d’inclusion par {{nurse}}",
    "examineSuggestion": "Examiner la demande",
    "reject": "Refuser",
    "accept": "Valider la proposition",
    "addPatient": "Proposition d’inclusion par {{nurse}}",
    "history": {
      "title": "Historique des propositions d’inclusion",
      "createdAt": "Date de demande",
      "doctor": "Médecin",
      "name": "Nom du patient",
      "birthDate": "Date de naissance",
      "email": "Adresse email",
      "status": "Statut d'inclusion",
      "cancelDemand": "Annuler la demande",
      "cancelDemandTitle": "Annuler la demande d'inclusion",
      "cancelDemandDescription": "Êtes-vous sûr de vouloir annuler cette demande d'inclusion ? Cette action est irréversible.",
      "noInclusion": "Aucune proposition d'inclusion"
    }
  },
  "diabetesForms": {
    "telemonitoring": "Télésurveillance",
    "createPatient": "Ajouter un patient",
    "patientCreated": "Le patient a été créé avec succès",
    "clickToView": "Cliquez pour voir le patient",
    "addDescription": "Ajouter les objectifs thérapeutiques",
    "addInsulin": "Passage à l'insuline",
    "addPatient": "Ajouter le patient",
    "addNurseInclusion": "Pré-inclure un patient",
    "addPrescription": "Ajouter une ordonnance",
    "addProvider": "Nouveau prestataire",
    "tier": "Niveau de remboursement",
    "criteria": "Critère d’inclusion",
    "criteriaBase": "Socle",
    "criteriaBaseHeader": "Socle",
    "criteriaBaseInfo": "Suivi d'un(e) patient(e) ayant un diabète de type 1, mise en \nroute d'une insuline basale chez un diabétique de type 2, suivi \ndu DT2 sous multi-injections ",
    "criteriaLevel1": "Niveau 1",
    "criteriaLevel1Header": "Niveau 1",
    "criteriaLevel1Info": "Découverte d'un diabète de type 1 chez un(e) patient(e) adulte, \nsuivi du diabète de type 1 chez un(e) patient(e) adolescent(e), \nsituation de déséquilibres transitoires (corticothérapie), \nsuivi d’un diabète gestationnel",
    "criteriaLevel2": "Niveau 2",
    "criteriaLevel2Header": "Niveau 2",
    "criteriaLevel2Info": "Découverte d'un diabète de type 1 chez un(e) patient(e)\nadolescent(e), suivi d'adolescents en écarts de soins,\ngrossesse d'une femme diabétique",
    "criteriaMeaningBase": "Ce critère d'inclusion correspond à un remboursement médecin de niveau socle",
    "criteriaMeaningLevel1": "Ce critère d'inclusion correspond à un remboursement médecin de niveau 1",
    "criteriaMeaningLevel2": "Ce critère d'inclusion correspond à un remboursement médecin de niveau 2",
    "dates": "Programme en cours",
    "diabetesAndSchema": "Diabète et dispositif",
    "diabetesType": "Diabète",
    "duration": "Durée du télésuivi (en mois)",
    "eitherObjectiveOrFile": "Les objectifs thérapeutiques doivent être remplis et/ou un fichier doit être ajouté",
    "existingPatient": {
      "title": "Ce patient est déjà présent sur Stēto",
      "monitoredByMe": "Un patient avec cette adresse email ou ce numéro de téléphone existe déjà dans votre patientèle Stēto. Vous pouvez le réinclure directement depuis son profil patient. S'il s'agit d'un autre patient partageant les mêmes coordonnées (ex: conjoint), merci de vous rapprocher de votre contact Stēto.",
      "monitoredByOther": "Ce patient est déjà télésuivi par un autre médecin sur Stēto. Contactez Stēto pour poursuivre l'inclusion.",
      "goToPatient": "Voir le patient"
    },
    "generatePrescription": "Générer l'ordonnance",
    "goals": "Protocole de prise en charge et objectifs thérapeutiques",
    "goalsNone": "Aucun objectif défini",
    "goalsShort": "Objectifs thérapeutiques",
    "uploadGoals": "Joindre des objectifs thérapeutiques",
    "nurseInformation": "Informations pour l'infirmier (facultatif)",
    "treatmentPrescription": "Ordonnance de traitement",
    "referralLetter": "Courrier d'adressage",
    "hasUntilTerm": "Suivi jusqu'au terme",
    "hsp": "Prestataire de santé",
    "inclusionCriteriaLabel": {
      "adultDiscoveryD1": "Découverte d'un DT1 chez un adulte",
      "adultMonitoringD1": "Suivi du DT1 chez un adulte",
      "basePrice": "Tarif Socle",
      "corticotherapie": "Situation de déséquilibres transitoires",
      "gestationalInsulined": "Diabète gestationnel sous insuline",
      "level1Price": "Tarif Niveau 1",
      "level2Price": "Tarif Niveau 2",
      "monitoringD2": "Suivi du DT2 sous insuline",
      "noRefund": "Non Remboursé",
      "pregnateD": "Grossesse d'une femme diabétique",
      "pumpHybridInitiation": "Initiation et suivi d'une pompe à insuline en boucle semi-fermée",
      "pumpInitiation": "Initiation d'un traitement par pompe à insuline",
      "pumpMonitoring": "Suivi d'un traitement par pompe à insuline",
      "startBasalD2": "Mise en route d'une insuline basale chez un DT2",
      "teenCareGap": "Suivi d'adolescents en écarts de soins",
      "teenDiscoveryD1": "Découverte d'un DT1 chez un adolescent",
      "teenMonitoringD1": "Suivi du DT1 chez un adolescent"
    },
    "insuletSupportedPumps": "<0>Insulet: Omnipod Dash et </0><1>Omnipod 5 (nouveau)</1>",
    "insulin": {
      "insulinPen": "Stylo",
      "insulinPump": "Pompe",
      "insulinPumpsComingSoon": "Le suivi des patients sous pompe arrive bientôt sur Stēto !",
      "noInsulin": "Sans insuline"
    },
    "insulinScheme": "Dispositif",
    "maximumWeight": "Le poids doit être inférieur à 1000 Kg",
    "medtronicSupportedPumps": "<0>Medtronic: </0><1>MiniMed 640G, 740G et 780G (nouveau)</1>",
    "minimumWeight": "Le poids doit être supérieur à 0 Kg",
    "months": "mois",
    "noInsulinMonitoringHelpText": "le diabète gestationnel non insuliné n’est pas éligible à la télésurveillance remboursée, la patiente ne sera donc pas accompagnée par votre infirmier(ère). Lorsque votre patiente commence une insulinothérapie, cliquez sur \"Passage à l'insuline\" pour lancer l'accompagnement infirmier.",
    "nonTelemonitoredPatient": "Patiente sans accompagnement infirmier",
    "otherHSP": "Nouveau prestataire - Stēto vous contactera",
    "periodStart": "Date de début",
    "prescription": "Ordonnance de télésurveillance",
    "prescriptionAddition": "Ajout de l'ordonnance",
    "prescriptionDescription": "ou ajouter une ordonnance pour trois mois démarrant le",
    "prescriptionDownload": "Télécharger l'ordonnance",
    "prescriptionDuration": "Durée de prescription",
    "pumpModel": "Modèle de la pompe",
    "prescriptionGeneration": "Génération de l'ordonnance",
    "prescriptionLabel": "Ajouter un fichier",
    "prescriptionNone": "Aucune ordonnance fournie",
    "prescriptionSignSuccess": "L'ordonnance a été signée avec succès.",
    "prescriptionSignature": "Signature",
    "prescriptionTooltip": "L’ordonnance doit inclure les éléments suivants :\n\n- nom du patient\n- âge\n- poids\n- désignation “télésurveillance diabète”\n- durée: 3 mois\n- plateforme: Stēto",
    "renew": "Renouveler",
    "restartMonitoring": "Renouveler",
    "renewPatient": "Renouveler le patient",
    "renewed": "Renouvelé",
    "cannotRenewDeceased": "Patient décédé",
    "cannotRenewDeceasedTooltip": "Le patient a été indiqué comme étant décédé et son télésuivi ne peut donc être renouvelé, merci de contacter le support Stēto en cas d'erreur.",
    "responsibleDoctor": "Médecin référent",
    "responsibleNurse": "Infirmier",
    "restriction": "Ce patient a déjà été suivi pendant 6 mois consécutifs en niveau 1 ou 2. Seuls les critères d'inclusion de niveau socle sont donc disponibles.",
    "signAndAddPatient": "Signer et ajouter le patient",
    "signAndRenewPatient": "Signer et renouveler le patient",
    "supportedPumpsInfo": "De nouvelles pompes seront ajoutées régulièrement dans les prochains mois",
    "supportedPumpsTitle": "Pompes disponibles sur Stēto",
    "tandemSupportedPumps": "<0>Tandem: t:slim X2 et t:slim X2 Control IQ</0>",
    "telemonitoring": "Télésurveillance",
    "termDate": "Terme de la grossesse",
    "noFile": "Aucun fichier",
    "attachments": "Pièces jointes",
    "writeGoals": "Rédiger des objectifs thérapeutiques",
    "editGoals": "Modifier les objectifs",
    "goalsUpdated": "Objectifs thérapeutiques mis à jour",
    "goalsAttachmentUpdated": "Pièce jointe des objectifs thérapeutiques mise à jour",
    "goalsAttachmentDeleted": "Pièce jointe des objectifs thérapeutiques supprimée",
    "treatmentPrescriptionUpdated": "Ordonnance de traitement mise à jour",
    "treatmentPrescriptionDeleted": "Ordonnance de traitement supprimée",
    "uploadTreatmentPrescription": "Joindre une ordonnance de traitement",
    "referralLetterUpdated": "Courrier d'adressage mis à jour",
    "referralLetterDeleted": "Courrier d'adressage supprimé",
    "uploadReferralLetter": "Joindre un courrier d'adressage"
  },
  "errors": {
    "emailOrPhoneAlreadyInUse": "Cet email ou téléphone est déjà utilisé par un de vos patients",
    "unknownErrorFull": "Une erreur technique est survenue. Veuillez contacter le support.",
    "accountAlreadyExists": "Ce patient a déjà un compte, merci de contacter le support.",
    "carePlanAlreadyRenewed": "Le télésuivi a déjà été renouvelé",
    "carePlansOverlapping": "Les dates de télésuivi chevauchent celles du télésuivi actuel",
    "dateFormat": "Le format de la date n'est pas valide",
    "fileSizeError": "La taille du fichier ne doit pas dépasser {{max_size}}: {{size}} / {{max_size}}",
    "invalidPhoneNumber": "Numéro de téléphone invalide",
    "or": "ou",
    "pageNotFound": "La page n'existe pas",
    "title": "Erreur",
    "unauthorizedPatientAccess": "Le patient n'existe pas ou vous n'avez pas les droits pour visualiser ce patient",
    "unknownError": "Une erreur technique est survenue",
    "userAlreadyExists": "Ce patient a déjà un compte, merci de contacter {{supportEmail}}",
    "waitAFewMinutes": "Veuillez patienter quelques minutes"
  },
  "fileReports": {
    "noData": "Aucun rapport disponible pour ces dates"
  },
  "food": {
    "carbs": "Glucides",
    "carbsUnit": "g",
    "comments": "Commentaire",
    "meal": "Repas",
    "size": "Consistance",
    "title": "Repas"
  },
  "form": {
    "atLeastOne": "Au moins un des champs doit être rempli",
    "date": {
      "format": "JJ/MM/AAAA",
      "future": "La date doit être dans le passé",
      "invalid": "La date n'est pas valide (JJ/MM/AAAA)",
      "past": "La date doit être dans le futur"
    },
    "email": {
      "invalid": "Adresse email non valide",
      "label": "Adresse email",
      "required": "Une adresse e-mail est requise"
    },
    "file": {
      "label": "Fichier",
      "required": "Uniquement les fichiers de type {{extensions}} sont supportés",
      "tooBig": "Le fichier ne doit pas dépasser 10 Mo"
    },
    "number": {
      "integer": "Le champs doit être un nombre entier",
      "invalid": "Le champs doit être un nombre",
      "max": "Le champs est supérieur à la valeur maximale",
      "min": "Le champs est inférieur à la valeur minimale",
      "positive": "Le champs doit être positif"
    },
    "pastDate": "La date ne peut pas être antérieure à la date actuelle",
    "phone": {
      "invalid": "Numéro de téléphone non valide",
      "label": "Numéro de téléphone",
      "required": "Un numéro de téléphone est requis"
    },
    "helperPhone": {
      "label": "Aidant pour la connexion (facultatif)",
      "placeholder": "Numéro de téléphone"
    },
    "required": "Le champs est requis",
    "text": {
      "comment": "Commentaire",
      "firstnameRequired": "Le prénom est requis",
      "lastnameRequired": "Le nom de famille est requis",
      "required": "Le champs est requis"
    }
  },
  "glycemia": {
    "hyperglycemia_one": "Hyperglycémie",
    "hyperglycemia_other": "Hyperglycémies",
    "hypoglycemia_one": "Hypoglycémie",
    "hypoglycemia_other": "Hypoglycémies",
    "title": "Glycémie"
  },
  "identityValidation": {
    "subtitle": "L'identité du patient ci-dessous doit être validée, avant de pouvoir continuer",
    "title": "Validation de l'identité de votre patient"
  },
  "impersonationWarning": "Vous êtes actuellement en mode d'impersonation",
  "inclusionAgent": {
    "accept": "Valider",
    "startTelemonitoring": "Démarrer le suivi",
    "cancel": "Annuler",
    "contactPatientTitle": "Contact du patient",
    "contactPatient": "Nous allons contacter le patient et vous notifierons de son choix",
    "disappear": "Le patient va disparaître de la liste",
    "includePatient": "Inclure le patient",
    "inclusionRequestSent": "Demande de suivi envoyée",
    "patientAccepted": "Suivi accepté par le patient",
    "phonePlaceholder": "Numéro de téléphone",
    "reject": "Décliner",
    "rejected": "Demande de suivi rejetée",
    "requiredPhone": "Nous avons besoin d'un numéro de téléphone pour proposer le suivi au patient",
    "stats": {
      "TBR": "TBR",
      "TIR": "TIR",
      "CV": "CV",
      "GMI": "GMI",
      "hypo_count": "Nb. Hypo"
    },
    "source": {
      "robot": "Agent",
      "tooltip": "Proposition d’inclusion par Agent Stēto"
    },
    "title": "Propositions d'inclusions",
    "viewOnLibreView": "Voir sur LibreView",
    "noMoreSuggestions": "Aucune proposition d'inclusion pour le moment.",
    "lastStep": "Dernière étape"
  },
  "pumpMode": {
    "title": "Système de pompe",
    "auto": "Boucle fermée",
    "manual": "Mode manuel"
  },
  "inputs": {
    "browse": "Parcourir..."
  },
  "insulin": {
    "averageInsulinPerDay": "Moy. insuline/jour",
    "averageNbBolusInjectionsPerDay": "Moy. nb. bolus/jour",
    "averageNbBolusPerDay": "Moy. nb. bolus/jour",
    "averageNbInjectionsPerDay": "Moy. nb. injections/jour",
    "basalInsulinPerDay": "Insuline basale / jour",
    "bolusInsulinPerDay": "Insuline bolus / jour",
    "carbs": "Glucides",
    "carbsRatio": "Ratio",
    "correction": "Correction",
    "fastInsulinPerDay": "Insuline rapide / jour",
    "foodInsulin": "Repas",
    "glycemia": "Glucose",
    "insulinSensitivity": "Sensibilité",
    "iob": "Insuline active",
    "quantity": "Délivrée",
    "reason": "Raison",
    "slowInsulinPerDay": "Insuline lente / jour",
    "suggested": "Suggérée",
    "suggestedCorrection": "Cor. suggérée",
    "suggestedFoodInsulin": "Repas suggérée",
    "targetGlycemia": "Glycémie cible",
    "title": "Insuline",
    "type": "Type"
  },
  "insulinPump": {
    "activeInsulinTime": "Temps insuline active",
    "basalRate": "Débit basal",
    "carbsRatio": "Ratio",
    "insulinSensitivity": "Sensibilité",
    "lastUpload": "Dernier téléchargement",
    "model": "Modèle de pompe",
    "profile": "Profil",
    "profiles": "Paramètres de la pompe",
    "targetBloodGlucose": "Glycémie cible",
    "timeRange": "",
    "total": "Total",
    "units": {
      "activeInsulinTime": "min",
      "basalRate": "U/h",
      "carbsRatio": "g/U",
      "insulinSensitivity": "mg/dL/U",
      "targetBloodGlucose": "mg/dL"
    }
  },
  "patientSync": {
    "title": "Synchronisation",
    "indexTitle": "Mes plateformes",
    "ongoingImportTitle": "Mes patients en cours d'import",
    "accessDenied": "La fonctionnalité d'ajout de patients par interopérabilité LibreView n'est pas disponible pour le moment.",
    "accessDeniedDescription": "Veuillez vous rapprocher de votre contact Stēto pour configurer la connexion.\nSi vous souhaitez appairer votre compte LibreView pour importer vos patients dans Stēto, merci de vous rapprocher de votre contact.",
    "index": {
      "intro": "Synchronisez vos plateformes constructeurs pour identifier les patients éligibles à la télésurveillance",
      "sectionTitle": "Plateformes"
    },
    "libreview": {
      "title": "Abbott LibreView",
      "subtitle": "Abbott · FreeStyle Libre 2, 2+, select et 3",
      "connected": "Connecté",
      "description": "Importez les patients de votre clinique LibreView dans Stēto.",
      "importPatients": "Importer des patients",
      "connectClinic": "Connecter ma clinique",
      "connectionTitle": "Abbott LibreView",
      "connectionBody": "Pour le moment, l’appairage de votre clinique LibreView se fait exclusivement avec l’aide de votre contact Stēto. Si vous souhaitez appairer votre compte LibreView pour importer vos patients dans Stēto, merci de vous rapprocher de votre contact.\n\nUne fois l’appairage réussi, rafraichissez cette page",
      "refresh": "Rafraichir la page",
      "close": "Fermer"
    },
    "lgc": {
      "title": "Logiciel de Gestion du Cabinet",
      "connectionTitle": "Logiciel de Gestion du Cabinet",
      "connectionBody": "Veuillez vous rapprocher de votre contact Stēto pour configurer la connexion.",
      "subtitle": "Doctolib, Weda, Maiia, AxiSanté, ...",
      "importPatients": "Importer des patients",
      "connectSoftware": "Connecter mon logiciel",
      "close": "Fermer"
    },
    "groupedInclusion": {
      "selectPatients": "Valider la sélection ({{count}})",
      "proposeTelemonitoring": "Proposer la TLS ({{count}} patients)",
      "proposeTelemonitoringSuccess": "Proposition de TLS réussie pour {{count}} patients"
    },
    "libreviewTable": {
      "name": "Patient",
      "tir": "TIR",
      "tbr": "TBR",
      "age": "Âge",
      "lastDataSince": "Dernière donnée",
      "ignore": "Fin de suivi",
      "patientIgnored": "Patient marqué « Plus suivi »",
      "lessThanADay": "Moins d'un jour",
      "filters": {
        "tir": "TIR (%) inférieur à",
        "tbr": "TBR (%) supérieur à",
        "lastData": "Dernière donnée",
        "and": "ET",
        "or": "OU",
        "lastDataOptions": {
          "lt1m": "Moins d'un mois",
          "lt3m": "Moins de 3 mois",
          "all": "Tous les patients"
        },
        "reset": "Réinitialiser les filtres",
        "summary": "{{total}} patients sur Libreview · {{matching}} correspondants aux filtres appliqués · {{selected}} sélectionnés"
      }
    },
    "ongoingImport": {
      "title": "Complétez les numéros de téléphone",
      "subtitle": "Sur vos {{count}} patients importés, {{withPhone}} ont un numéro et peuvent être proposés en télésurveillance. {{missingPhone}} numéros restent à saisir.",
      "sidebar": {
        "selfTitle": "Complétez les numéros vous-même",
        "selfBody": "Saisissez les numéros à gauche au fur et à mesure, puis cliquez sur « Proposer la TLS ». Stēto contactera les patients pour leur proposer d'être suivi en télésurveillance",
        "completeLaterButton": "Compléter plus tard",
        "delegateTitle": "Déléguez au secrétariat",
        "delegateBody": "Téléchargez la liste des patients à compléter et transmettez-la à votre secrétariat.",
        "delegateButton": "Télécharger la liste",
        "delegateSuccess": "Liste téléchargée",
        "lgcTitle": "Ouvrez un accès logiciel temporaire",
        "lgcBody": "Autorisez un agent Stēto à récupérer les numéros depuis votre logiciel de cabinet",
        "lgcButton": "Configurer l'accès"
      }
    },
    "ongoingInclusionTable": {
      "name": "Patient",
      "phone": "Téléphone",
      "phoneSaved": "Numéro de téléphone enregistré",
      "deleted": "Patient supprimé de la liste"
    }
  },
  "languageFlag": "🇫🇷",
  "languageFull": "🇫🇷 Français",
  "languages": {
    "en": "Anglais (English)",
    "fr": "Français"
  },
  "messaging": {
    "all": "Tous les messages",
    "deleted": "Message supprimé",
    "everybody": "Tout le monde",
    "me": "Moi",
    "medicalStaff": "Equipe médicale",
    "noMessages": "Aucun message pour le moment",
    "noNurse": "Patiente non accompagnée par votre infirmier",
    "patientOnly": "Message pour votre patient uniquement",
    "reactions": {
      "react": "Réagir avec {{emoji}}",
      "badge": "Réaction {{emoji}}, {{count}} au total",
      "openPicker": "Ajouter une réaction",
      "pickerLabel": "Choisir une réaction"
    },
    "readBy": "Lu par",
    "recipient": "Destinataire ",
    "toAllPlaceholder": "Message visible par le patient et l'équipe médicale",
    "toPractitionerPlaceholder": "Message visible par l'équipe médicale seulement",
    "unread": "Non lus"
  },
  "models": {
    "activityIntensity": {
      "high": "Élevée",
      "low": "Faible",
      "medium": "Moyenne",
      "unknown": "Non spécifié"
    },
    "pumpModel": {
      "unknown": "Je ne sais pas",
      "minimed": "MiniMed autres",
      "minimed640g": "MiniMed 640G",
      "minimed740g": "MiniMed 740G",
      "minimed780g": "MiniMed 780G",
      "omnipodDash": "Omnipod Dash",
      "omnipod5": "Omnipod 5",
      "tandemSlimX2": "T:slim X2",
      "tandemSlimX2ControlIQ": "T:slim X2 Control IQ"
    },
    "diabetesType": {
      "gestational": "Gestationnel",
      "gestationalNoInsulin": "DG non insuliné",
      "gestationalWithInsulin": "DG insuliné",
      "type1": "Type 1",
      "type2": "Type 2",
      "unknown": "Inconnu"
    },
    "nurseInclusionPatientStatus": {
      "suggestedToDoc": "Proposé",
      "doctorRefused": "Refusé",
      "patientIncluded": "Inclus",
      "nurseCancelled": "Annulé",
      "unknown": "Inconnu"
    },
    "insulinReason": {
      "basal": "Insuline basale",
      "basal_short": "Basale",
      "bolus": "Insuline bolus",
      "bolus_short": "Bolus"
    },
    "insulinType": {
      "fast": "Insuline rapide",
      "fast_short": "Ins. rapide",
      "slow": "Insuline lente",
      "slow_short": "Ins. lente"
    },
    "meal": {
      "breakfast": "Petit-déjeuner",
      "dinner": "Dîner",
      "lunch": "Déjeuner",
      "snack": "Collation",
      "unknown": "Repas non spécifié"
    },
    "mealSize": {
      "heavy": "Consistant",
      "light": "Léger",
      "medium": "Moyen",
      "unknown": "Non spécifié"
    },
    "medicationSchema": {
      "insulinPen": "Stylo",
      "insulinPump": "Pompe",
      "noInsulin": "Sans insuline"
    },
    "practitionerBillingStatus": {
      "error": "Erreur",
      "processed": "Traité",
      "toProcess": "A traiter"
    },
    "practitionerBillingType": {
      "quotation": "Résumés pour cotation",
      "retrocessionDoctor": "Rétrocession Médecin",
      "retrocessionSteto": "Rétrocession Stēto"
    },
    "pumpEventCategory": {
      "basalRateChanged": "Changement de débit basal",
      "cannulaFilled": "Purge canule",
      "cartridgeFilled": "Retour piston",
      "dailyBasal": "Basal journalier",
      "podChanged": "Pod remplacé",
      "podActivated": "Pod activé",
      "podDeactivated": "Pod désactivé",
      "profileChanged": "Profil de pompe modifié",
      "tubingFilled": "Purge tubulure"
    },
    "pumpMode": {
      "closedLoop": "Mode boucle fermée",
      "manual": "Mode manuel",
      "noControl": "Mode manuel",
      "openLoop": "Mode manuel",
      "pining": "Mode manuel"
    },
    "reinclusionSuggestion": {
      "pendingTag": "Suggestion de réinclusion"
    },
    "reportCategory": {
      "other": "Autre",
      "perceivedHyperglycemia": "Hyperglycémie ressentie",
      "perceivedHypoglycemia": "Hypoglycémie ressentie",
      "severeHypoglycemia": "Hypoglycémie sévère",
      "techAlert": "Problèmes techniques"
    },
    "telemonitoringTag": {
      "active": "Active",
      "active_long": "Télésurveillance active",
      "expired": "Expirée",
      "expiredRecently": "Expirée récemment",
      "expiredRecently_long": "Télésurveillance expirée récemment",
      "expired_long": "Télésurveillance expirée",
      "expiringSoon": "Expire bientôt",
      "expiringSoon_long": "Télésurveillance expire bientôt",
      "gestationalNoInsulin": "DG non insuliné",
      "gestationalNoInsulin_long": "Diabète gestationnel non insuliné",
      "nurseAskedForReinclusion": "Réinclusion proposée",
      "nurseAskedForReinclusion_long": "Réinclusion proposée par l'infirmier",
      "onboarding": "Installation en cours",
      "onboarding_long": "Patient en cours d'installation"
    },
    "userMode": {
      "exercising": "Mode sport",
      "normal": "Mode normal",
      "sleeping": "Mode sommeil"
    },
    "contactType": {
      "nurse": "Infirmier",
      "family": "Famille",
      "helper": "Aidant",
      "unknown": "Autre"
    },
    "contactRelationship": {
      "grandParent": "Grand-parent",
      "parent": "Parent",
      "parentInLaw": "Parent par alliance",
      "partner": "Conjoint",
      "child": "Enfant",
      "sibling": "Frère ou soeur",
      "cousin": "Cousin",
      "friend": "Ami",
      "unknown": "Autre"
    },
    "refuseReinclusionReason": {
      "noClinicalNeed": "Pas de besoin clinique",
      "nonCompliant": "Patient non consentant",
      "other": "Autre",
      "unknown": "Inconnu"
    }
  },
  "navbar": {
    "disconnect": "Me déconnecter",
    "myPatients": "Mes patients",
    "practitionerBilling": "Facturation",
    "patientSync": "Synchronisation"
  },
  "notifications": {
    "none": "Aucune notification active.",
    "title": "Notifications actives"
  },
  "pages": {
    "account": {
      "about": {
        "address": "12 Boulevard de Port Royal",
        "class": "Dispositif médical de classe I",
        "description": "Stēto est un produit de santé réglementé qui porte, au titre de cette réglementation, un marquage CE de classe I. Voir notice d’utilisation. L’application Stēto est une solution de télésuivi du diabète réalisée et développée par :",
        "name": "Stēto",
        "postCode": "75005 Paris",
        "rcs": "918012121 RCS de Paris",
        "title": "À propos de Stēto"
      },
      "absenceMessage": {
        "title": "Message d'absence",
        "helpText": "Envoyez un message à tous vos patients en cours de télésurveillance afin de les prévenir de vos absences.",
        "template": "Bonjour,\nJe vous informe que je serai en congé du XX/XX/XXX au XX/XX/XXX.\nCordialement,\n{{name}}",
        "send": "Envoyer",
        "confirmTitle": "Confirmation d'envoi",
        "confirmIntro": "Je confirme l'envoi à tous mes patients en télésurveillance active du message suivant :",
        "confirm": "Confirmer",
        "successTitle": "Message envoyé",
        "successSubtitle": "Votre message a été envoyé à vos patients.",
        "errorMessage": "Une erreur est survenue lors de l'envoi du message. Veuillez réessayer."
      },
      "generalInformation": {
        "title": "Informations générales"
      },
      "language": {
        "title": "Langue"
      },
      "preferences": {
        "dgNoInsulinPatientToDoctor": "Nouveau message d'une patiente DG non suivie par un infirmier",
        "doctorToNurse": "Nouveau message médecin",
        "nursePing": "Nouveau patient signalé",
        "nurseToDoctor": "Nouveau message infirmier",
        "patientExpiresSoon": "Patient télésurveillé expire bientôt",
        "patientExpiresSoonNurse": "Patient télésurveillé expire bientôt",
        "patientToNurse": "Nouveau message patient",
        "title": "Préférences de notifications par email"
      },
      "security": {
        "title": "Sécurité",
        "updatePassword": "Changer de mot de passe"
      },
      "terms": {
        "title": "Conditions générales d'utilisation"
      },
      "title": "Mon compte",
      "userHelp": {
        "contactUs": "Contactez nous à {{supportEmail}}",
        "description": "Besoin d'aide ?",
        "or": "ou",
        "title": "Besoin d'aide ?",
        "userManual": "consultez notre manuel"
      }
    },
    "search": {
      "title": "Recherche d'antériorité",
      "CTA": "Chercher",
      "CTARedirectButton": "Rechercher un patient",
      "form": {
        "dob": "Date de naissance",
        "NIR": "Numéro NIR",
        "names": "Nom / Prénom(s)"
      },
      "table": {
        "birthName": "Nom de naissance",
        "usedLastName": "Nom utilisé",
        "firstRegulatoryFirstName": "Premier prénom de naissance",
        "usedFirstName": "Prénom utilisé",
        "dob": "Date de naissance",
        "gender": "Sexe",
        "status": "Statut de l’identité",
        "nir": "Numéro NIR",
        "CTA": "Voir",
        "noData": "Aucun résultat"
      }
    },
    "addMeasurement": {
      "choose": "Choisir"
    },
    "addMeasurementFile": {
      "chooseFile": "Choisir un fichier",
      "chooseMedicalDeviceToLoad": "Choisir mon dispositif médical à décharger",
      "dexcom": {
        "alreadyIntegrated": "Dexcom est déjà intégré",
        "alreadyIntegratedHelpText": "Vous avez déjà intégré votre compte Dexcom.\nSi vous souhaitez le réinitialiser, vous pouvez contacter le support au {{supportPhone}} ou nous envoyer un mail à {{supportEmail}}",
        "clarityNotEnabled": "Clarity non activé",
        "clarityNotEnabledHelpText": "Vous devez activer Clarity pour pouvoir intégrer votre compte Dexcom.\nPour cela, rendez-vous sur l'application Dexcom et activez Clarity.\nSi vous avez besoin d'aide, vous pouvez contacter le support au {{supportPhone}} ou nous envoyer un mail à {{supportEmail}}",
        "dexcomData": "Dexcom CGM",
        "integrationDenied": "L'intégration de Dexcom a été refusée",
        "integrationDeniedHelpText": "Afin que votre médecin puisse accéder à vos données de glycémie, vous devez autoriser l'accès à votre compte Dexcom.\nPour cela, vous pouvez réessayer de vous connecter à votre compte Dexcom en cliquant sur le bouton ci-dessous.",
        "integrationError": "Une erreur est survenue lors de l'intégration de Dexcom",
        "integrationErrorHelpText": "Une erreur est survenue lors de la connexion à votre compte Dexcom.\nNous vous conseillons de réessayer d'ici quelques minutes. Si cela ne fonctionne toujours pas, vous pouvez contacter le support au {{supportPhone}} ou nous envoyer un mail à {{supportEmail}}",
        "integrationSuccess": "Intégration Dexcom faite avec succès",
        "integrationSuccessHelpText": "Votre compte Dexcom a bien été intégré.\nVous pouvez maintenant accéder à vos données de glycémie dans l'application Stēto.",
        "title": "Dexcom"
      },
      "error": "Une erreur est survenue lors de l'enregistrement de votre fichier",
      "fsl": {
        "addData": "Décharger les données de mon Smartphone avec un FreeStyle Libre",
        "instructions": "Vous devez vous rendre d'abord sur le site de LibreView pour récupérer votre fichier de données CSV puis sélectionnez le fichier :"
      },
      "fslWithAbbottSmartphone": "Capteur FreeStyle Libre scanné avec mon smartphone ABBOTT",
      "noFileChosen": "Aucun fichier choisi",
      "success": "Votre fichier a bien été enregistré"
    },
    "login": {
      "connection": "Connexion",
      "disclaimer": "Bienvenue sur Stēto !\nNous sommes ravis de vous voir ici.\nSi vous êtes un patient ou un membre de l'entourage du patient, vous devez préalablement avoir créé votre compte à partir de l'application mobile avant de poursuivre.",
      "practitionerTitle": "Vous êtes un soignant",
      "practitionerPill": "Accédez à votre espace soignant sur l'application web Stēto",
      "practitionerNoAccount": "Pas encore de compte Stēto ?\nÉcrivez-nous à contact@steto.care, nous reviendrons vers vous dans les plus brefs délais",
      "patientTitle": "Vous êtes un patient",
      "patientPill": "Téléchargez l'application mobile sur votre smartphone pour démarrer votre suivi",
      "patientInstructions": "Depuis votre téléphone, connectez-vous sur le site app.steto.care puis cliquez sur l'un des deux boutons ci-dessus",
      "patientDetails": "Vous êtes connecté avec un compte patient. Vous devez télécharger l'application mobile depuis votre téléphone pour accéder à votre suivi. Pour ce faire, connectez-vous sur le site app.steto.care depuis votre téléphone puis cliquez sur l'un des deux boutons ci-dessous : ",
      "iphone": "iPhone",
      "otherSmartphone": "Autre smartphone"
    },
    "notFound": {
      "title": "La page n'existe pas"
    },
    "patientMonitoring": {
      "agp": {
        "glycemiaMgDl": "Glycémie en mg/dL",
        "longTermEvolution": "Voir l'évolution long terme",
        "title": "Profil AGP"
      },
      "dailyDataError": "Erreur du chargement des données journalières",
      "glycemia": {
        "averageMeasuresPerDay": "Moy. mesures/jour",
        "averageReader": "Moy. gluc. lecteur",
        "averageSensor": "Moy. gluc. capteur",
        "coefVariation": "Coef. variation",
        "estimatedHba1c": "HbA1c estimée",
        "nbHypo": "Nb. hypo.",
        "sensorUsage": "Utilisation capteur",
        "title": "Profils glycémiques journaliers"
      },
      "insulin": {
        "averageInsulinPerDay": "Moy. insuline/jour",
        "averageNbBolusPerDay": "Moy. nb. bolus/jour",
        "averageNbInjectionsPerDay": "Moy. nb. injections/jour",
        "fast": "Insuline rapide",
        "slow": "Insuline lente"
      },
      "loadMoreRecent": "Afficher de la donnée plus récente",
      "noData": "Aucune donnée à afficher",
      "patient": {
        "title": "Informations patient",
        "helperSection": "Aidant à contacter pour la connexion (facultatif)",
        "age": "{{age}} ans",
        "diabetes": {
          "gestational": "Diabète gestationnel",
          "type1": "Diabète type 1",
          "type2": "Diabète type 2"
        },
        "insulin": {
          "insulinPen": "Stylo",
          "insulinPump": "Pompe",
          "noInsulin": "Non insuliné"
        },
        "insulinScheme": "Dispositif d'insulinothérapie",
        "unspecifiedInsulinScheme": "Schéma insulinique non renseigné",
        "unspecifiedDiabetesType": "Type de diabète non renseigné"
      },
      "title": "Suivi du patient"
    },
    "patientMedicalFile": {
      "diabetesAndDevices": "Diabète et dispositifs médicaux",
      "editNote": "Éditer la note",
      "emptyNote": "\"<i>Vous n'avez pas encore de note pour ce patient</i>\"",
      "lastSync": "Donnée la plus récente",
      "neverSynced": "jamais",
      "noteSuccess": "Note sauvegardée avec succès",
      "notes": "Bloc-note équipe médicale",
      "thereIs": "il y a {{duration}}",
      "writeNote": "Rédiger une note"
    },
    "patients": {
      "addPatient": "Ajouter un patient",
      "addNurseInclusion": "Pré-inclure un patient",
      "all": "Tous",
      "columns": {
        "patientName": "Patient"
      },
      "columnVisibility": {
        "title": "Colonnes affichées",
        "restoreDefaults": "Réinitialiser",
        "toggle": "Colonnes"
      },
      "diabetesType": "Diabète",
      "editPatient": "Modifier",
      "pregnant": "Grossesses suivies",
      "lastSeen": {
        "header": "Vu il y a",
        "olderThanMonth": "Plus de 1 mois",
        "olderThanTwoWeeks": "Plus de 2 semaines",
        "recent": "Moins de 2 semaines",
        "unknown": "Jamais",
        "never": "Jamais"
      },
      "messages": "Messages",
      "monitored": "DT1/2 suivis",
      "notifications": "Patient signalé",
      "patientInfo": "Informations de votre patient",
      "referentDoctor": "Docteur",
      "tlsNurse": "Infirmier",
      "renewal": "Renouvellement",
      "telemonitoring": "Télésurveillance",
      "title": "Mes patients",
      "toConsult": "Patient signalé"
    },
    "patientSettings": {
      "telemonitoring": {
        "activate": "Activer la télésurveillance",
        "edit": "Modifier la télésurveillance",
        "title": "Télésurveillance"
      }
    },
    "practitionerBilling": {
      "fileName": "Nom du fichier",
      "lastUpdate": "Dernière mise à jour",
      "noData": "Aucun fichier disponible",
      "period": "Période",
      "status": "Statut",
      "title": "Facturation"
    },
    "renewPopup": {
      "body": "Le télésuivi de votre patient a expiré, il n'est donc plus accompagné par votre infirmier. ​Souhaitez-vous poursuivre son accompagnement ?",
      "decideLater": "Décider plus tard",
      "no": "Non",
      "title": "Renouvellement de votre patient",
      "yes": "Oui"
    }
  },
  "patientEvents": {
    "carePlanDeleted": "Impossible de connecter le patient, un terme a été mis à son suivi.",
    "carePlanRenewed": {
      "other": "{{doctorName}} a renouvelé le télésuivi.",
      "self": "Vous avez renouvelé le télésuivi du patient"
    },
    "decidedNotToRenew": {
      "afterEndCP": {
        "other": "{{doctorName}} a indiqué ne pas renouveler le télésuivi",
        "self": "Vous avez mis un terme au télésuivi du patient"
      },
      "beforeEndCP": {
        "other": "{{doctorName}} a indiqué que le télésuivi ne sera pas renouvelé à l’issue de la prescription en cours",
        "self": "Vous avez mis un terme au télésuivi du patient, à l’issue de la prescription en cours"
      }
    },
    "careplanInterrupted": {
      "self": "Vous avez interrompu le télésuivi du patient",
      "other": "{{doctorName}} a interrompu le télésuivi du patient",
      "steto": "Stēto a mis un terme au télésuivi du patient sur demande de l'équipe médicale"
    },
    "aircall": {
      "callNotAnswered": "Tentative d'appel du patient par l'équipe Stēto",
      "callAnswered": "Appel entre l'équipe Stēto et le patient - Durée : {{duration}} minutes",
      "smsSentBySteto": "SMS envoyé au patient par l'équipe Stēto",
      "smsSentByPatient": "SMS envoyé par le patient à l'équipe Stēto"
    },
    "nurseReinclusion": {
      "selfRequested": "Vous avez proposé la réinclusion de ce patient",
      "otherRequested": "{{doctorName}} a proposé la réinclusion de ce patient",
      "selfCancelled": "Vous avez annulé la réinclusion de ce patient",
      "otherCancelled": "{{doctorName}} a annulé la réinclusion de ce patient",
      "selfRefused": "Vous avez refusé la réinclusion de ce patient",
      "otherRefused": "{{doctorName}} a refusé la réinclusion de ce patient"
    },
    "header": "Évènement",
    "rpmStarted": "Patient connecté, le suivi peut démarrer",
    "deceased": "Suite au décès du patient le télésuivi est interrompu"
  },
  "patientInfo": {
    "countryOfBirth": "Né en",
    "countryOfBirth_female": "Née en",
    "countryOfBirth_male": "Né en",
    "noPhoneNumber": "Téléphone non renseigné",
    "placeOfBirth": "Né à",
    "placeOfBirth_female": "Née à",
    "placeOfBirth_male": "Né à"
  },
  "patientNavigation": {
    "dailyView": "Vue journalière",
    "dataManagement": "Gestion des données",
    "lastSeen": "Actif il y a",
    "medicalFile": "Dossier médical",
    "monitoring": "Suivi diabète",
    "noFirstConnection": "Pas de première connexion",
    "notice": {
      "banner": "Votre infirmier a signalé ce patient",
      "cancelNotify": "Annuler le signalement",
      "mitigateNotify": "Valider le signalement",
      "notified": "Patient signalé",
      "notifyDoctor": "Signaler au médecin"
    },
    "renewalNudge": {
      "ctas": {
        "continue": "Poursuivre le suivi",
        "stop_later": "Arrêter le suivi dans {{days}} jours",
        "stop_now": "Mettre un terme au suivi",
        "stop_today": "Arrêter le suivi aujourd'hui",
        "stop_tomorrow": "Arrêter le suivi demain"
      },
      "expired": "L’ordonnance de {{patientName}} a expiré il y a {{days}} jours. Prévenez votre infirmier si il doit arrêter d’accompagner votre patiente.",
      "expired_yesterday": "L’ordonnance de {{patientName}} a expiré hier. Prévenez votre infirmier si il doit arrêter d’accompagner votre patiente.",
      "expires_soon": "L’ordonnance de {{patientName}} expire dans {{days}} jours. Prévenez votre infirmier si il doit continuer d’accompagner votre patient à l’issue de la prescription en cours.",
      "expires_today": "L’ordonnance de {{patientName}} expire aujourd’hui. Prévenez votre infirmier si il doit continuer d’accompagner votre patient à l’issue de la prescription en cours.",
      "expires_tomorrow": "L’ordonnance de {{patientName}} expire demain. Prévenez votre infirmier si il doit continuer d’accompagner votre patient à l’issue de la prescription en cours."
    },
    "settings": "Paramètres"
  },
  "periodicity": {
    "customize": "{{count}} jours",
    "oneMonth": "30 jours",
    "oneWeek": "7 jours",
    "sixMonths": "180 jours",
    "threeMonths": "90 jours",
    "twoWeeks": "14 jours",
    "yesterday": "Hier"
  },
  "prescription": {
    "renew": "Renouveler",
    "sign": "Signer"
  },
  "profile": {
    "address": "Adresse",
    "birth": "Informations de naissance",
    "birthCity": "Ville de naissance",
    "birthCountry": "Pays de naissance",
    "birthDate": "Date de naissance",
    "birthDate_short": "Naissance",
    "birthPlace": "Lieu de naissance",
    "birthPostCode": "Code postal de naissance",
    "diabetologist": "Diabétologue",
    "doctor": "Médecin",
    "email": "Email",
    "female": "Femme",
    "firstname": "Prénom",
    "gender": "Sexe",
    "identityFirstname": "1er prénom de naissance",
    "identityFirstnames": "Prénom(s) de naissance",
    "identityLastname": "Nom de naissance",
    "ins": "Identifiant National de Santé",
    "lastname": "Nom",
    "male": "Homme",
    "moreInfo": "Afficher toutes les informations",
    "notGiven": "Non renseigné",
    "nurse": "Infirmier",
    "oid": "Numéro OID",
    "phone": "Téléphone",
    "profession": "Profession",
    "profile": "Profil",
    "ssn": "Numéro de sécurité sociale",
    "title": "Profil",
    "usedFirstname": "Prénom utilisé",
    "usedLastname": "Nom utilisé"
  },
  "pumpEvents": {
    "category": "Événement",
    "insulin": "Insuline",
    "isNotTemp": "Non",
    "isTemp": "Oui",
    "primeSize": "Taille de la purge",
    "tempRate": "Débit Temp.",
    "tempRatePercent": "Débit temporaire",
    "title": "Événement de pompe"
  },
  "reinclusion": {
    "actionButton": "Proposer la réinclusion",
    "activeTag": "Réinclusion proposée",
    "agent": {
      "banner": {
        "acceptCTA": "Proposer la réinclusion",
        "refuseCTA": "Ne pas proposer",
        "tir": "TIR",
        "tbr": "TBR",
        "autoArchiveTag": "Expire le {{date}}",
        "autoArchiveTooltip": "Sans action de votre part, la proposition sera archivée automatiquement le {{date}}\nafin de pouvoir vous proposer de nouvelles suggestions.",
        "notTelemonitoredSince": "Ce patient n’est plus télésuivi depuis {{days}} jours",
        "title": "Stēto a identifié que ce patient pourrait bénéficier d’un nouvel accompagnement en télésurveillance.\nSouhaitez-vous proposer au médecin de réinclure ce patient ?",
        "titlePatientMessage": "Ce patient, dont le suivi est expiré, a envoyé un message.\nSouhaitez-vous proposer au médecin de réinclure ce patient ?"
      },
      "proposeSuccessToast": "Proposition envoyée",
      "refuseModal": {
        "cancel": "Annuler",
        "otherPlaceholder": "Précisez la raison",
        "submit": "Valider",
        "subtitle": "Pour quelle raison jugez-vous que la réinclusion n’est pas pertinente pour ce patient ?",
        "title": "Aidez-nous à affiner nos suggestions !"
      },
      "refuseSuccessToast": "Merci pour votre retour"
    },
    "cancelAction": "Annuler la proposition",
    "doctorCTAAccept": "Réinclure",
    "doctorCTADeny": "Refuser",
    "doctorTitle": "Votre infirmier vous propose de réinclure ce patient. Il n'est plus télésuivi depuis {{days}} jours.",
    "doctorTitleWithNurseName": "{{nurseName}} vous propose de réinclure ce patient. Il n'est plus télésuivi depuis {{days}} jours.",
    "proposeModalCancel": "Annuler",
    "proposeModalPlaceholder": "Raison de la proposition",
    "proposeModalSubmit": "Valider la proposition",
    "proposeModalTitle": "Message au médecin"
  },
  "report": {
    "category": "Catégorie",
    "message": "Message",
    "title": "Événement"
  },
  "search": {
    "searchPatient": "Rechercher un patient"
  },
  "support": {
    "byEmail": "par email à ",
    "byPhone": "par téléphone au",
    "contactUs": "Contactez le support",
    "or": "ou"
  },
  "thresholdSettings": {
    "afterMeal": "Après le repas",
    "alertThresholds": "Seuils des notifications",
    "beforeBreakfast": "À jeun",
    "beforeMeal": "Avant le repas",
    "gestationalThresholds": "Seuils glycémiques",
    "hyperglycemia": "Hyperglycémie",
    "hypoglycemia": "Hypoglycémie",
    "normal": "Glycémie cible",
    "severeHyperglycemia": "Hyperglycémie sévère",
    "severeHypoglycemia": "Hypoglycémie sévère",
    "thresholdUpdated": "Seuil mis à jour",
    "thresholds": "Seuils",
    "units": "mg/dL"
  },
  "QaTools": {
    "deleteData": "Delete",
    "deleteDataTitle": "Delete glycemia data",
    "downloadCSV": "Download CSV",
    "downloadCSVTitle": "Download glycemia data",
    "generateData": "Generate",
    "generateDataTitle": "Generate glycemia data",
    "glycemiaDataManagement": "Glycemia data management",
    "onboarding": "Onboarding management",
    "skipOnboarding": "Skip onboarding",
    "uploadCSV": "Upload CSV",
    "uploadCSVTitle": "Upload glycemia data"
  },
  "fileManager": {
    "noFile": "Aucun"
  },
  "table": {
    "sorting": {
      "sortable": "Trier la colonne",
      "ascending": "Trié par ordre croissant",
      "descending": "Trié par ordre décroissant"
    }
  }
}
